import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#050A1F] px-6 text-white" data-testid="not-found-page">
      <div className="text-center">
        <div className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37]">Error 404</div>
        <h1 className="mt-4 font-serif text-6xl font-light">Page not found.</h1>
        <p className="mt-4 text-white/60">The page you&apos;re looking for isn&apos;t part of our vault.</p>
        <Link
          to="/"
          className="mt-8 inline-block border border-[#D4AF37] bg-[#D4AF37] px-8 py-3 text-xs uppercase tracking-[0.32em] text-[#050A1F] hover:bg-[#F3E5AB]"
        >
          Return Home
        </Link>
      </div>
    </div>
  );
}
